export const PAGINATION_REQUEST = "PAGINATION_REQUEST";
export const PAGINATION_SUCCESS = "PAGINATION_SUCCESS";
export const PAGINATION_FAIL = "PAGINATION_FAIL";
